import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Articles.css';
import { pageWrapperStyle } from '../../styles/pageStyles.js';

const Articles = () => {
  const articles = [
    {
      id: 1,
      slug: 'shopify-vs-woocommerce-honest-truth',
      title: "Shopify vs WooCommerce (WordPress): The Brutally Honest Truth No One Tells You (Even at $1M in Sales)",
      date: "January 15, 2025",
      excerpt: "If you're launching or scaling an eCommerce store, chances are you've hit the Shopify vs WooCommerce debate—and probably walked away more confused than ever. Both are popular, both are powerful, and both can technically \"work\" for your business. But here's the thing: the differences between Shopify and WooCommerce only get more dramatic the bigger your store becomes...",
      readTime: "8 min read",
      category: "eCommerce"
    }
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      style={{ ...pageWrapperStyle, paddingTop: 0 }}
    >
      <section className="articles section">
        <div className="container">
          <motion.div
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h2>Articles</h2>
            <p>Insights, tutorials, and deep dives into web development, e-commerce, and digital strategy.</p>
          </motion.div>

          <motion.div
            className="articles-grid"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
          {articles.map(article => (
            <article key={article.id} className="article-card">
              <div className="article-meta">
                <span className="article-category">{article.category}</span>
                <span className="article-date">{article.date}</span>
                <span className="article-read-time">{article.readTime}</span>
              </div>
              <h2 className="article-title">
                <Link to={`/articles/${article.slug}`}>{article.title}</Link>
              </h2>
              <p className="article-excerpt">{article.excerpt}</p>
              <Link to={`/articles/${article.slug}`} className="read-more-btn">
                Read Full Article →
              </Link>
            </article>
          ))}
          </motion.div>
        </div>
      </section>
    </motion.div>
  );
};

export default Articles;
